import { Form, TextArea } from 'antd-mobile';

/**
 * 输入框模板
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 * } props 
 * @returns 
 */
export function BpmFormTextArea(props) {
  const { postName, label, message, disabled, required, maxLength } = props.item
  const { setFormInfo } = props
  return (
    <Form.Item
      name={postName}
      label={label}
      rules={[{ required: required, message: message }]}
    >
      <TextArea
        maxLength={maxLength ? maxLength : 500}
        disabled={disabled}
        onChange={value => setFormInfo(postName, value)}
        placeholder={message}
        autoSize={{ minRows: 1, maxRows: 3 }}
      />
    </Form.Item>
  )
}